// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"3f8654c4","325":"273e7fc2","575":"afda299d","676":"273e7fc2","922":"83051382"}[chunkId] + ".chunk.css";
};